(function () {
  function setup(root) {
    const menu = root.querySelector('.menu-drawer__menu.has-submenu');
    if (!menu || menu.dataset.customMenuReady === 'true') return;
    menu.dataset.customMenuReady = 'true';

    const items = [...menu.children].filter((entry) => entry.classList.contains('menu-drawer__list-item--flat'));

    function activate(item) {
      items.forEach((entry) => {
        const on = entry === item;
        entry.classList.toggle('is-active', on);
        const tab = entry.querySelector(':scope > a.menu-drawer__menu-item--mainlist');
        if (tab && entry.querySelector(':scope > .menu-drawer__menu')) {
          tab.setAttribute('aria-expanded', on ? 'true' : 'false');
        }
      });
    }

    items.forEach((item) => {
      const tab = item.querySelector(':scope > a.menu-drawer__menu-item--mainlist');
      const panel = item.querySelector(':scope > .menu-drawer__menu');
      if (!tab || !panel) return;
      tab.setAttribute('aria-expanded', item.classList.contains('is-active') ? 'true' : 'false');
      tab.addEventListener('click', (event) => {
        if (item.classList.contains('is-active') && item.dataset.customMenuChosen === 'true') return;
        event.preventDefault();
        items.forEach((entry) => {
          delete entry.dataset.customMenuChosen;
        });
        item.dataset.customMenuChosen = 'true';
        activate(item);
      });
    });
  }

  function boot() {
    document.querySelectorAll('.header__drawer').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
